import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { COMPANY, ABOUT_FEATURES } from '../mock';

const About = () => {
  return (
    <div>
      <section className="ea-hero-gradient py-16">
        <div className="mx-auto max-w-7xl px-5 text-center lg:px-8">
          <h1 className="font-display text-4xl font-extrabold text-white sm:text-5xl">About E.A. Lead Solutions</h1>
          <p className="mt-4 text-lg text-white/85">Management Services Co. — Your Trusted Property Services Partner in London</p>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-2 lg:px-8">
          <div>
            <h2 className="ea-heading text-3xl font-bold">Who We Are</h2>
            <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-gray-600">
              <p>E.A. Lead Solutions Management Services Co. is a London-based property services company delivering professional residential and commercial maintenance solutions.</p>
              <p>Part of the E.A. Business Goals Limited group, we bring the same commitment to quality, efficiency, and client satisfaction that defines our parent company — now applied to the home and property services sector.</p>
              <p>Our team of vetted, qualified professionals covers every aspect of property maintenance: from emergency plumbing and electrical work to complete painting makeovers and deep cleaning services.</p>
            </div>
          </div>
          <div className="flex justify-center">
            <div className="rounded-3xl bg-[#e9f3ec] p-10">
              <img src={COMPANY.logo} alt="E.A. Lead Solutions" className="h-60 w-60 object-contain" />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#e9f3ec] py-20">
        <div className="mx-auto max-w-6xl px-5 lg:px-8">
          <h2 className="ea-heading text-center text-3xl font-bold">What Sets Us Apart</h2>
          <div className="mt-12 grid gap-8 md:grid-cols-3">
            {ABOUT_FEATURES.map((f) => {
              const Icon = f.icon;
              return (
                <div key={f.title} className="ea-card-hover rounded-2xl bg-white p-8 text-center shadow-sm">
                  <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-xl bg-[#e9f3ec]">
                    <Icon className="h-7 w-7 text-[#3a9b5c]" />
                  </div>
                  <h3 className="mt-5 font-display text-lg font-bold text-[#1b4f72]">{f.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-gray-600">{f.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="mx-auto max-w-4xl px-5 text-center lg:px-8">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#e9f3ec]">
            <MapPin className="h-7 w-7 text-[#3a9b5c]" />
          </div>
          <h2 className="ea-heading mt-5 text-3xl font-bold">Our Coverage</h2>
          <p className="mt-5 text-[15px] leading-relaxed text-gray-600">
            We currently service <strong className="text-[#1b4f72]">all London boroughs</strong> — from the City of London to Zone 6.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-gray-600">
            Whether you are in Westminster, Camden, Tower Hamlets, Greenwich, Croydon, or anywhere in between — our team is ready to help.
          </p>
          <p className="mt-6 inline-block rounded-full bg-[#e9f3ec] px-5 py-2 text-sm font-semibold text-[#3a9b5c]">Serving All of Greater London</p>
        </div>
      </section>

      <section className="ea-cta-gradient py-16">
        <div className="mx-auto max-w-4xl px-5 text-center lg:px-8">
          <h2 className="font-display text-3xl font-bold text-white sm:text-4xl">Ready to Get Started?</h2>
          <p className="mt-4 text-white/80">Request your first service today and experience the E.A. Lead Solutions difference.</p>
          <Link to="/request-a-service" className="mt-8 inline-block rounded-full bg-[#3a9b5c] px-8 py-3.5 font-semibold text-white shadow-md transition-all hover:bg-[#46ad6a]">
            Request a Service
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
